import * as React from 'react';
import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import _ from 'lodash';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';

import { currentStage } from '../../api/api';

import useGlobalStatus from '../../hook/useGlobalStatus';

import { LanguageIcon, KeyboardArrowDownOutlinedIcon } from '../../constants/images';

import { useTheme } from '@mui/material/styles';


const CustomButton = styled(Button)(props => ({
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)'
  }
}))

const options = [
  {
    id: 'zh',
    name: '繁體中文',
  },
  {
    id: 'en',
    name: 'English',
  },
  {
    id: 'ja',
    name: '日本語',
  }
];

const Language = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const { locale, setLocale } = useGlobalStatus();
  const [Language, setLanguage] = useState();
  const [target, setTarget] = useState(null);
  const isOpen = Boolean(target);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const currentOption = options.filter((item) => !(currentStage.includes('ext') && item.id === 'en'));

  useEffect(() => {
    const optionIndex = _.findIndex(options, el => locale.includes(el.id));

    if (optionIndex !== -1) {
      setLanguage(options[optionIndex].name);
    } else {
      setLanguage(options[0].name);
    }
  }, [locale])

  const handleMenuOpen = (event) => {
    setTarget(event.currentTarget);
  };

  const handleMenuClose = () => {
    setTarget(null);
  };

  const handleMenuItemClick = (e, index) => {
    setSelectedIndex(index);
    setLocale(currentOption[index].id);
    setTarget(null);
  }

  // console.log('locale', locale)

  return (
    <>
      <CustomButton
        startIcon={<LanguageIcon />}
        endIcon={<KeyboardArrowDownOutlinedIcon />}
        onClick={handleMenuOpen}
        sx={{ mr: 1, color: '#fff', textTransform: 'none', minWidth: '140px' }}
      >
        {Language}
      </CustomButton>

      <Menu
        anchorEl={target}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        open={isOpen}
        onClose={handleMenuClose}
        style={{
          zIndex: 2000,
        }}
        sx={{
          '& .MuiPaper-root': {
            minWidth: 120,
          }
        }}
      >
        {currentOption.map((option, index) => (
          <MenuItem
            key={`${option}_${index}`}
            selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, index)}
          >
            {option.name}
          </MenuItem>
        ))}
      </Menu>

    </>
  )
}

export default Language;